import { useAvivaSelector } from "@redux/hook"
import { ModalViewConfig } from "./modal"
import React from 'react'

export default function ModalView() {
    const { isModalShow, ModalViewComponent } = useAvivaSelector(state => state.modalView)

    if (isModalShow) {
        const Component = ModalViewConfig[ModalViewComponent]?.viewComponent
        return <Component />;
    }
    else {
        return (
            <></>
        )
    }

}
